// State data with local information for AI demos
export const stateData = {
  AL: {
    name: "Alabama",
    abbr: "AL",
    capital: "Montgomery",
    majorCities: ["Birmingham", "Huntsville", "Mobile", "Montgomery", "Tuscaloosa"],
    areaCodes: ["205", "251", "256", "334", "938"],
    timezone: "Central",
    climate: "humid subtropical",
    seasonalNotes: "Hot, humid summers. Mild winters. Hurricane risk along Gulf Coast.",
    hvacNotes: "AC essential May-September. Humidity control important. Occasional winter heating.",
    plumbingNotes: "Rare pipe freezing. Focus on humidity/mold prevention. Hurricane prep.",
    electricalNotes: "Storm damage common. Generator demand during hurricane season.",
    roofingNotes: "Hurricane-rated materials recommended in coastal areas. Heat-reflective options popular."
  },
  AK: {
    name: "Alaska",
    abbr: "AK",
    capital: "Juneau",
    majorCities: ["Anchorage", "Fairbanks", "Juneau", "Sitka", "Ketchikan", "Wasilla", "Palmer"],
    areaCodes: ["907"],
    timezone: "Alaska",
    climate: "subarctic to arctic",
    seasonalNotes: "Extreme winters (-20°F to -40°F). Short summers. Permafrost in many areas.",
    hvacNotes: "Heating critical 8+ months/year. Furnace failures are emergencies. Oil and gas heat common.",
    plumbingNotes: "Frozen pipes extremely common. Heat tape essential. Septic challenges with permafrost.",
    electricalNotes: "Block heater circuits common. Generator backup important. Extended dark periods.",
    roofingNotes: "Heavy snow loads. Ice dam prevention critical. Metal roofs popular."
  },
  AZ: {
    name: "Arizona",
    abbr: "AZ",
    capital: "Phoenix",
    majorCities: ["Phoenix", "Tucson", "Mesa", "Chandler", "Scottsdale", "Glendale", "Tempe"],
    areaCodes: ["480", "520", "602", "623", "928"],
    timezone: "Mountain (no DST)",
    climate: "desert/arid",
    seasonalNotes: "Extreme summer heat (110°F+). Mild winters. Monsoon season July-September.",
    hvacNotes: "AC absolutely critical. Units run constantly in summer. Evaporative coolers in dry areas.",
    plumbingNotes: "Hard water issues. Minimal freeze risk. Pool equipment maintenance.",
    electricalNotes: "High electrical demand for cooling. Solar popular. Dust storm damage.",
    roofingNotes: "Tile roofs common. UV damage significant. Cool roof coatings important."
  },
  AR: {
    name: "Arkansas",
    abbr: "AR",
    capital: "Little Rock",
    majorCities: ["Little Rock", "Fort Smith", "Fayetteville", "Springdale", "Jonesboro"],
    areaCodes: ["479", "501", "870"],
    timezone: "Central",
    climate: "humid subtropical",
    seasonalNotes: "Hot, humid summers. Mild winters with occasional ice storms. Tornado risk.",
    hvacNotes: "AC essential in summer. Heating needed in winter. Humidity control important.",
    plumbingNotes: "Occasional freeze risk. Humidity/mold prevention.",
    electricalNotes: "Storm damage from tornadoes. Generator backup recommended.",
    roofingNotes: "Wind and hail damage common. Impact-resistant materials recommended."
  },
  CA: {
    name: "California",
    abbr: "CA",
    capital: "Sacramento",
    majorCities: ["Los Angeles", "San Francisco", "San Diego", "San Jose", "Sacramento", "Fresno", "Oakland"],
    areaCodes: ["209", "213", "310", "323", "408", "415", "510", "559", "619", "626", "650", "707", "714", "760", "805", "818", "831", "858", "909", "916", "925", "949", "951"],
    timezone: "Pacific",
    climate: "mediterranean to desert",
    seasonalNotes: "Varies by region. Coastal mild, inland hot. Wildfire season. Earthquake risk.",
    hvacNotes: "AC important inland. Coastal areas mild. Air quality concerns during fire season.",
    plumbingNotes: "Drought awareness. Water conservation. Earthquake shut-off valves.",
    electricalNotes: "Solar incentives strong. EV charging growing. Power shutoffs during fire risk.",
    roofingNotes: "Fire-resistant materials required in many areas. Solar integration common."
  },
  CO: {
    name: "Colorado",
    abbr: "CO",
    capital: "Denver",
    majorCities: ["Denver", "Colorado Springs", "Aurora", "Fort Collins", "Boulder", "Lakewood"],
    areaCodes: ["303", "719", "720", "970"],
    timezone: "Mountain",
    climate: "semi-arid/alpine",
    seasonalNotes: "300+ days of sunshine. Cold winters, mild summers. Rapid weather changes.",
    hvacNotes: "Heating essential in winter. AC less critical due to low humidity. High altitude considerations.",
    plumbingNotes: "Freeze protection important. Altitude affects water pressure.",
    electricalNotes: "Solar popular due to sunshine. Lightning storm damage.",
    roofingNotes: "Hail damage very common. Impact-resistant shingles recommended. Heavy snow in mountains."
  },
  CT: {
    name: "Connecticut",
    abbr: "CT",
    capital: "Hartford",
    majorCities: ["Bridgeport", "New Haven", "Hartford", "Stamford", "Waterbury", "Norwalk"],
    areaCodes: ["203", "475", "860", "959"],
    timezone: "Eastern",
    climate: "humid continental",
    seasonalNotes: "Four distinct seasons. Cold, snowy winters. Hot, humid summers. Nor'easters.",
    hvacNotes: "Heating critical in winter. AC needed in summer. Oil heat still common.",
    plumbingNotes: "Freeze protection essential. Old infrastructure in historic areas.",
    electricalNotes: "Storm outages common. Backup generators popular.",
    roofingNotes: "Snow load considerations. Ice dam prevention. Historic home expertise."
  },
  DE: {
    name: "Delaware",
    abbr: "DE",
    capital: "Dover",
    majorCities: ["Wilmington", "Dover", "Newark", "Middletown", "Smyrna"],
    areaCodes: ["302"],
    timezone: "Eastern",
    climate: "humid subtropical",
    seasonalNotes: "Moderate climate. Hot, humid summers. Mild winters. Coastal flooding risk.",
    hvacNotes: "AC essential in summer. Moderate heating needs. Humidity control.",
    plumbingNotes: "Coastal flooding concerns. Salt air corrosion near coast.",
    electricalNotes: "Storm surge protection. Coastal corrosion resistance.",
    roofingNotes: "Wind resistance for coastal areas. Moderate snow loads."
  },
  FL: {
    name: "Florida",
    abbr: "FL",
    capital: "Tallahassee",
    majorCities: ["Jacksonville", "Miami", "Tampa", "Orlando", "St. Petersburg", "Fort Lauderdale"],
    areaCodes: ["239", "305", "321", "352", "386", "407", "561", "727", "754", "772", "786", "813", "850", "863", "904", "941", "954"],
    timezone: "Eastern/Central",
    climate: "tropical/subtropical",
    seasonalNotes: "Hot, humid year-round. Hurricane season June-November. Afternoon thunderstorms.",
    hvacNotes: "AC runs year-round. Humidity control critical. Hurricane-rated equipment.",
    plumbingNotes: "No freeze risk (mostly). Hurricane prep. Saltwater intrusion near coast.",
    electricalNotes: "Lightning capital of US. Surge protection essential. Hurricane shutters.",
    roofingNotes: "Hurricane-rated required. Impact-resistant materials. Frequent inspections."
  },
  GA: {
    name: "Georgia",
    abbr: "GA",
    capital: "Atlanta",
    majorCities: ["Atlanta", "Augusta", "Columbus", "Savannah", "Athens", "Macon"],
    areaCodes: ["229", "404", "470", "478", "678", "706", "762", "770", "912", "943"],
    timezone: "Eastern",
    climate: "humid subtropical",
    seasonalNotes: "Hot, humid summers. Mild winters. Mountains cooler. Occasional ice storms in north.",
    hvacNotes: "AC essential spring through fall. Moderate heating. Humidity control.",
    plumbingNotes: "Rare freeze issues except mountains. Humidity/mold prevention.",
    electricalNotes: "Summer storm damage. Growing solar adoption.",
    roofingNotes: "Heat-reflective options popular. Occasional hail in north."
  },
  HI: {
    name: "Hawaii",
    abbr: "HI",
    capital: "Honolulu",
    majorCities: ["Honolulu", "Hilo", "Kailua", "Kapolei", "Pearl City"],
    areaCodes: ["808"],
    timezone: "Hawaii-Aleutian",
    climate: "tropical",
    seasonalNotes: "Warm year-round. Trade winds. Microclimates vary greatly. Hurricane risk.",
    hvacNotes: "AC common but not always necessary. Trade wind ventilation. Humidity control.",
    plumbingNotes: "No freeze risk. Salt air corrosion. Rainwater catchment on Big Island.",
    electricalNotes: "Highest electricity costs in US. Solar very popular. Salt corrosion.",
    roofingNotes: "Hurricane-rated materials. Salt air corrosion resistance. Metal roofs popular."
  },
  ID: {
    name: "Idaho",
    abbr: "ID",
    capital: "Boise",
    majorCities: ["Boise", "Meridian", "Nampa", "Idaho Falls", "Pocatello", "Caldwell"],
    areaCodes: ["208", "986"],
    timezone: "Mountain/Pacific",
    climate: "semi-arid to alpine",
    seasonalNotes: "Cold winters, hot summers. Mountain areas have heavy snow. High desert in south.",
    hvacNotes: "Heating essential in winter. AC becoming more common. Low humidity.",
    plumbingNotes: "Freeze protection critical. Well water common in rural areas.",
    electricalNotes: "Hydropower keeps rates low. Rural properties may need generators.",
    roofingNotes: "Heavy snow loads in mountains. Metal roofs popular."
  },
  IL: {
    name: "Illinois",
    abbr: "IL",
    capital: "Springfield",
    majorCities: ["Chicago", "Aurora", "Naperville", "Joliet", "Rockford", "Springfield"],
    areaCodes: ["217", "224", "309", "312", "331", "618", "630", "708", "773", "779", "815", "847", "872"],
    timezone: "Central",
    climate: "humid continental",
    seasonalNotes: "Cold winters, hot summers. Lake effect snow near Chicago. Tornado risk.",
    hvacNotes: "Both heating and AC essential. Extreme temperature swings possible.",
    plumbingNotes: "Freeze protection critical. Old infrastructure in Chicago.",
    electricalNotes: "Storm damage common. Backup generators recommended.",
    roofingNotes: "Ice dam prevention. Wind and hail damage. Flat roof expertise in cities."
  },
  IN: {
    name: "Indiana",
    abbr: "IN",
    capital: "Indianapolis",
    majorCities: ["Indianapolis", "Fort Wayne", "Evansville", "South Bend", "Carmel", "Bloomington"],
    areaCodes: ["219", "260", "317", "463", "574", "765", "812", "930"],
    timezone: "Eastern/Central",
    climate: "humid continental",
    seasonalNotes: "Four seasons. Cold winters, hot humid summers. Tornado alley.",
    hvacNotes: "Heating and AC both essential. Humidity control in summer.",
    plumbingNotes: "Freeze protection important. Basement flooding common.",
    electricalNotes: "Storm damage from tornadoes. Surge protection.",
    roofingNotes: "Wind and hail resistance. Ice dams in winter."
  },
  IA: {
    name: "Iowa",
    abbr: "IA",
    capital: "Des Moines",
    majorCities: ["Des Moines", "Cedar Rapids", "Davenport", "Sioux City", "Iowa City"],
    areaCodes: ["319", "515", "563", "641", "712"],
    timezone: "Central",
    climate: "humid continental",
    seasonalNotes: "Cold winters, hot summers. Severe thunderstorms and tornadoes. Flooding risk.",
    hvacNotes: "Heating critical in winter. AC essential in summer. Wide temp swings.",
    plumbingNotes: "Freeze protection essential. Flood mitigation in low areas.",
    electricalNotes: "Wind and storm damage. Rural areas may need backup power.",
    roofingNotes: "Hail damage very common. Wind resistance important."
  },
  KS: {
    name: "Kansas",
    abbr: "KS",
    capital: "Topeka",
    majorCities: ["Wichita", "Overland Park", "Kansas City", "Topeka", "Olathe", "Lawrence"],
    areaCodes: ["316", "620", "785", "913"],
    timezone: "Central/Mountain",
    climate: "humid subtropical to semi-arid",
    seasonalNotes: "Tornado alley. Hot summers, cold winters. Dramatic weather changes.",
    hvacNotes: "Both heating and AC essential. Storm shelters common.",
    plumbingNotes: "Freeze protection in winter. Hard water common.",
    electricalNotes: "Storm damage frequent. Backup generators important.",
    roofingNotes: "Hail and wind damage extremely common. Impact-resistant essential."
  },
  KY: {
    name: "Kentucky",
    abbr: "KY",
    capital: "Frankfort",
    majorCities: ["Louisville", "Lexington", "Bowling Green", "Owensboro", "Covington"],
    areaCodes: ["270", "364", "502", "606", "859"],
    timezone: "Eastern/Central",
    climate: "humid subtropical",
    seasonalNotes: "Four seasons. Hot humid summers, mild to cold winters. Occasional ice storms.",
    hvacNotes: "AC essential in summer. Heating needed in winter. Humidity control.",
    plumbingNotes: "Moderate freeze risk. Limestone geology affects water.",
    electricalNotes: "Storm damage from ice and wind. Coal region transitioning.",
    roofingNotes: "Mixed weather challenges. Historic homes common."
  },
  LA: {
    name: "Louisiana",
    abbr: "LA",
    capital: "Baton Rouge",
    majorCities: ["New Orleans", "Baton Rouge", "Shreveport", "Lafayette", "Lake Charles"],
    areaCodes: ["225", "318", "337", "504", "985"],
    timezone: "Central",
    climate: "humid subtropical",
    seasonalNotes: "Hot, humid most of year. Hurricane season. Heavy rainfall. Mild winters.",
    hvacNotes: "AC runs most of year. Humidity control critical. Hurricane prep.",
    plumbingNotes: "No freeze risk. Flood and hurricane prep. High water table.",
    electricalNotes: "Hurricane hardening important. Moisture protection.",
    roofingNotes: "Hurricane-rated materials. Frequent storm damage. Moisture resistance."
  },
  ME: {
    name: "Maine",
    abbr: "ME",
    capital: "Augusta",
    majorCities: ["Portland", "Lewiston", "Bangor", "South Portland", "Auburn"],
    areaCodes: ["207"],
    timezone: "Eastern",
    climate: "humid continental",
    seasonalNotes: "Cold, snowy winters. Mild summers. Nor'easters. Coastal vs inland variation.",
    hvacNotes: "Heating critical 6+ months. Oil and wood heat common. AC less essential.",
    plumbingNotes: "Freeze protection essential. Many older homes. Well water common.",
    electricalNotes: "Storm outages from nor'easters. Generators important. Older wiring.",
    roofingNotes: "Heavy snow loads. Ice dam prevention critical. Metal roofs popular."
  },
  MD: {
    name: "Maryland",
    abbr: "MD",
    capital: "Annapolis",
    majorCities: ["Baltimore", "Frederick", "Rockville", "Gaithersburg", "Bowie", "Annapolis"],
    areaCodes: ["240", "301", "410", "443", "667"],
    timezone: "Eastern",
    climate: "humid subtropical",
    seasonalNotes: "Four seasons. Hot humid summers, cold winters. Chesapeake Bay influence.",
    hvacNotes: "Both AC and heating essential. Humidity control in summer.",
    plumbingNotes: "Freeze protection in winter. Coastal areas have flooding concerns.",
    electricalNotes: "Storm damage from various weather. Dense suburban infrastructure.",
    roofingNotes: "All-weather durability. Historic home expertise in older areas."
  },
  MA: {
    name: "Massachusetts",
    abbr: "MA",
    capital: "Boston",
    majorCities: ["Boston", "Worcester", "Springfield", "Cambridge", "Lowell", "New Bedford"],
    areaCodes: ["339", "351", "413", "508", "617", "774", "781", "857", "978"],
    timezone: "Eastern",
    climate: "humid continental",
    seasonalNotes: "Cold snowy winters. Warm humid summers. Nor'easters. Coastal flooding.",
    hvacNotes: "Heating critical in winter. AC needed in summer. Many old buildings.",
    plumbingNotes: "Freeze protection essential. Very old infrastructure in cities.",
    electricalNotes: "Old wiring in historic buildings. Storm backup important.",
    roofingNotes: "Ice dams and snow loads. Historic building expertise. Flat roofs in cities."
  },
  MI: {
    name: "Michigan",
    abbr: "MI",
    capital: "Lansing",
    majorCities: ["Detroit", "Grand Rapids", "Warren", "Sterling Heights", "Ann Arbor", "Lansing"],
    areaCodes: ["231", "248", "269", "313", "517", "586", "616", "734", "810", "906", "947", "989"],
    timezone: "Eastern/Central",
    climate: "humid continental",
    seasonalNotes: "Lake effect snow. Cold winters, warm summers. Upper Peninsula very cold.",
    hvacNotes: "Heating critical. Lake effect areas need robust systems. AC in summer.",
    plumbingNotes: "Freeze protection essential. Many homes with basements.",
    electricalNotes: "Storm outages common. Industrial legacy infrastructure.",
    roofingNotes: "Heavy snow loads especially lake effect areas. Ice dam prevention."
  },
  MN: {
    name: "Minnesota",
    abbr: "MN",
    capital: "Saint Paul",
    majorCities: ["Minneapolis", "Saint Paul", "Rochester", "Duluth", "Bloomington"],
    areaCodes: ["218", "320", "507", "612", "651", "763", "952"],
    timezone: "Central",
    climate: "humid continental",
    seasonalNotes: "Very cold winters (-20°F+). Warm summers. Blizzards. 10,000+ lakes.",
    hvacNotes: "Heating absolutely critical. High-efficiency systems essential. AC in summer.",
    plumbingNotes: "Freeze protection critical. Heat tape common. Cabin plumbing winterization.",
    electricalNotes: "Cold weather affects equipment. Block heaters. Backup generators.",
    roofingNotes: "Extreme snow loads. Ice dam prevention critical. Energy efficiency focus."
  },
  MS: {
    name: "Mississippi",
    abbr: "MS",
    capital: "Jackson",
    majorCities: ["Jackson", "Gulfport", "Southaven", "Hattiesburg", "Biloxi"],
    areaCodes: ["228", "601", "662", "769"],
    timezone: "Central",
    climate: "humid subtropical",
    seasonalNotes: "Hot, humid summers. Mild winters. Hurricane risk on coast. Tornado risk.",
    hvacNotes: "AC essential most of year. Humidity control critical. Mild heating needs.",
    plumbingNotes: "Minimal freeze risk. Hurricane prep on coast. High humidity.",
    electricalNotes: "Storm damage from hurricanes and tornadoes. Moisture protection.",
    roofingNotes: "Hurricane-rated on coast. Heat reflection. Storm damage common."
  },
  MO: {
    name: "Missouri",
    abbr: "MO",
    capital: "Jefferson City",
    majorCities: ["Kansas City", "St. Louis", "Springfield", "Columbia", "Independence"],
    areaCodes: ["314", "417", "573", "636", "660", "816"],
    timezone: "Central",
    climate: "humid continental/subtropical",
    seasonalNotes: "Four seasons with extremes. Hot summers, cold winters. Tornado and ice storms.",
    hvacNotes: "Both heating and AC essential. Wide temperature variations.",
    plumbingNotes: "Freeze protection in winter. Basement flooding common.",
    electricalNotes: "Storm damage frequent. Ice storm outages.",
    roofingNotes: "Hail damage common. Wind resistance. Ice and heat extremes."
  },
  MT: {
    name: "Montana",
    abbr: "MT",
    capital: "Helena",
    majorCities: ["Billings", "Missoula", "Great Falls", "Bozeman", "Butte", "Helena"],
    areaCodes: ["406"],
    timezone: "Mountain",
    climate: "semi-arid to alpine",
    seasonalNotes: "Cold winters, mild summers. Chinook winds. Mountains have heavy snow.",
    hvacNotes: "Heating critical. Wood and propane common in rural areas. AC less common.",
    plumbingNotes: "Freeze protection essential. Well water common. Rural challenges.",
    electricalNotes: "Rural areas may be off-grid. Wind damage. Long distances.",
    roofingNotes: "Heavy snow in mountains. Wind resistance important. Metal roofs common."
  },
  NE: {
    name: "Nebraska",
    abbr: "NE",
    capital: "Lincoln",
    majorCities: ["Omaha", "Lincoln", "Bellevue", "Grand Island", "Kearney"],
    areaCodes: ["308", "402", "531"],
    timezone: "Central/Mountain",
    climate: "humid continental to semi-arid",
    seasonalNotes: "Cold winters, hot summers. Tornado alley. Dramatic weather changes.",
    hvacNotes: "Both heating and AC essential. Extreme temperature swings.",
    plumbingNotes: "Freeze protection critical. Rural well water. Hard water common.",
    electricalNotes: "Storm damage from tornadoes. Rural backup power needs.",
    roofingNotes: "Hail damage extremely common. Wind resistance critical."
  },
  NV: {
    name: "Nevada",
    abbr: "NV",
    capital: "Carson City",
    majorCities: ["Las Vegas", "Henderson", "Reno", "North Las Vegas", "Sparks", "Carson City"],
    areaCodes: ["702", "725", "775"],
    timezone: "Pacific",
    climate: "desert/semi-arid",
    seasonalNotes: "Hot, dry summers (115°F in Vegas). Cold high desert winters. Low humidity.",
    hvacNotes: "AC critical in summer (Vegas). Heating needed in winter especially Reno. Evap coolers.",
    plumbingNotes: "Hard water issues. Water conservation. Minimal freeze risk in south.",
    electricalNotes: "High cooling demand. Solar popular. Pool equipment.",
    roofingNotes: "UV and heat damage. Cool roof options. Tile common in Vegas."
  },
  NH: {
    name: "New Hampshire",
    abbr: "NH",
    capital: "Concord",
    majorCities: ["Manchester", "Nashua", "Concord", "Derry", "Rochester"],
    areaCodes: ["603"],
    timezone: "Eastern",
    climate: "humid continental",
    seasonalNotes: "Cold snowy winters. Mild summers. Mountains get more snow. Nor'easters.",
    hvacNotes: "Heating critical. Oil common. AC needed but summers short.",
    plumbingNotes: "Freeze protection essential. Old homes common. Well water in rural areas.",
    electricalNotes: "Storm outages from snow and wind. Many older homes.",
    roofingNotes: "Snow loads significant. Ice dam prevention. Historic home expertise."
  },
  NJ: {
    name: "New Jersey",
    abbr: "NJ",
    capital: "Trenton",
    majorCities: ["Newark", "Jersey City", "Paterson", "Elizabeth", "Trenton", "Edison"],
    areaCodes: ["201", "551", "609", "732", "848", "856", "862", "908", "973"],
    timezone: "Eastern",
    climate: "humid subtropical/continental",
    seasonalNotes: "Four seasons. Hot humid summers, cold winters. Coastal flooding risk.",
    hvacNotes: "Both AC and heating essential. Dense housing. Older systems common.",
    plumbingNotes: "Freeze protection. Old infrastructure. Coastal flooding concerns.",
    electricalNotes: "Dense infrastructure. Storm hardening after Sandy. Aging systems.",
    roofingNotes: "All-weather durability. Coastal wind resistance. Tight lot access."
  },
  NM: {
    name: "New Mexico",
    abbr: "NM",
    capital: "Santa Fe",
    majorCities: ["Albuquerque", "Las Cruces", "Rio Rancho", "Santa Fe", "Roswell"],
    areaCodes: ["505", "575"],
    timezone: "Mountain",
    climate: "semi-arid to arid",
    seasonalNotes: "High desert. Hot days, cool nights. Mountains have snow. Monsoon season.",
    hvacNotes: "AC in summer, heating in winter. Evaporative coolers effective. Adobe construction.",
    plumbingNotes: "Water conservation. Hard water. Freeze risk at altitude.",
    electricalNotes: "Solar very popular. Low humidity helps equipment.",
    roofingNotes: "Flat roofs common (Southwestern style). UV protection important."
  },
  NY: {
    name: "New York",
    abbr: "NY",
    capital: "Albany",
    majorCities: ["New York City", "Buffalo", "Rochester", "Syracuse", "Albany", "Yonkers"],
    areaCodes: ["212", "315", "332", "347", "516", "518", "585", "607", "631", "646", "680", "716", "718", "838", "845", "914", "917", "929", "934"],
    timezone: "Eastern",
    climate: "humid continental",
    seasonalNotes: "Cold winters (lake effect upstate). Hot summers. Wide regional variation.",
    hvacNotes: "Heating critical. AC essential in city, needed upstate. Steam heat in old buildings.",
    plumbingNotes: "Freeze protection. Very old infrastructure in NYC. Upstate well water.",
    electricalNotes: "Aging infrastructure in cities. Upstate storm damage. High demand.",
    roofingNotes: "Snow loads upstate. Flat roofs in city. Historic building expertise."
  },
  NC: {
    name: "North Carolina",
    abbr: "NC",
    capital: "Raleigh",
    majorCities: ["Charlotte", "Raleigh", "Greensboro", "Durham", "Winston-Salem", "Fayetteville"],
    areaCodes: ["252", "336", "704", "743", "828", "910", "919", "980", "984"],
    timezone: "Eastern",
    climate: "humid subtropical",
    seasonalNotes: "Mild climate overall. Mountains cold. Coast has hurricanes. Occasional ice storms.",
    hvacNotes: "AC essential in summer. Moderate heating. Mountains need more heat.",
    plumbingNotes: "Moderate freeze risk. Humidity control. Coastal hurricane prep.",
    electricalNotes: "Storm damage from hurricanes and ice. Growing tech sector demand.",
    roofingNotes: "Hurricane-rated on coast. Mountains have snow. All-weather needs."
  },
  ND: {
    name: "North Dakota",
    abbr: "ND",
    capital: "Bismarck",
    majorCities: ["Fargo", "Bismarck", "Grand Forks", "Minot", "West Fargo"],
    areaCodes: ["701"],
    timezone: "Central/Mountain",
    climate: "humid continental",
    seasonalNotes: "Extremely cold winters (-30°F+). Warm summers. Blizzards. Flooding.",
    hvacNotes: "Heating absolutely critical. High-efficiency essential. AC in summer.",
    plumbingNotes: "Freeze protection critical. Heat tape essential. Oil field areas busy.",
    electricalNotes: "Block heaters. Cold weather equipment. Rural backup power.",
    roofingNotes: "Extreme cold and snow. Ice dam prevention. Wind exposure."
  },
  OH: {
    name: "Ohio",
    abbr: "OH",
    capital: "Columbus",
    majorCities: ["Columbus", "Cleveland", "Cincinnati", "Toledo", "Akron", "Dayton"],
    areaCodes: ["216", "220", "234", "283", "326", "330", "380", "419", "440", "513", "567", "614", "740", "937"],
    timezone: "Eastern",
    climate: "humid continental",
    seasonalNotes: "Four seasons. Lake effect snow in north. Hot humid summers. Tornadoes.",
    hvacNotes: "Both heating and AC essential. Lake effect areas need robust heating.",
    plumbingNotes: "Freeze protection important. Many basements. Old infrastructure.",
    electricalNotes: "Storm damage common. Industrial legacy. Aging grids.",
    roofingNotes: "Snow loads in north. Hail damage. All-weather durability."
  },
  OK: {
    name: "Oklahoma",
    abbr: "OK",
    capital: "Oklahoma City",
    majorCities: ["Oklahoma City", "Tulsa", "Norman", "Broken Arrow", "Edmond", "Lawton"],
    areaCodes: ["405", "539", "572", "580", "918"],
    timezone: "Central",
    climate: "humid subtropical to semi-arid",
    seasonalNotes: "Tornado alley. Hot summers, variable winters. Dramatic weather changes.",
    hvacNotes: "AC essential in summer. Heating needed in winter. Storm shelters common.",
    plumbingNotes: "Variable freeze risk. Hard water. Earthquake considerations.",
    electricalNotes: "Storm damage very common. Backup power important.",
    roofingNotes: "Hail damage extremely common. Wind resistance critical. Frequent claims."
  },
  OR: {
    name: "Oregon",
    abbr: "OR",
    capital: "Salem",
    majorCities: ["Portland", "Salem", "Eugene", "Gresham", "Hillsboro", "Bend"],
    areaCodes: ["458", "503", "541", "971"],
    timezone: "Pacific/Mountain",
    climate: "oceanic to semi-arid",
    seasonalNotes: "Wet winters west side, dry east. Mild temperatures coast. Mountains have snow.",
    hvacNotes: "Heating more important than AC west side. East needs both. Heat pumps popular.",
    plumbingNotes: "Rain and moisture issues west. Freeze risk east and mountains.",
    electricalNotes: "Hydropower keeps rates low. Wildfire risk. Green energy focus.",
    roofingNotes: "Moss and moisture west side. Snow in mountains. Metal roofs popular."
  },
  PA: {
    name: "Pennsylvania",
    abbr: "PA",
    capital: "Harrisburg",
    majorCities: ["Philadelphia", "Pittsburgh", "Allentown", "Reading", "Erie", "Harrisburg"],
    areaCodes: ["215", "223", "267", "272", "412", "445", "484", "570", "582", "610", "717", "724", "814", "835", "878"],
    timezone: "Eastern",
    climate: "humid continental",
    seasonalNotes: "Four seasons. Cold winters, warm summers. Lake effect snow in Erie. Variable by region.",
    hvacNotes: "Both heating and AC essential. Many older homes with steam/radiator heat.",
    plumbingNotes: "Freeze protection important. Very old infrastructure in cities.",
    electricalNotes: "Old wiring in historic buildings. Storm outages. Industrial legacy.",
    roofingNotes: "Snow loads vary by region. Historic building expertise. Slate roofs."
  },
  RI: {
    name: "Rhode Island",
    abbr: "RI",
    capital: "Providence",
    majorCities: ["Providence", "Warwick", "Cranston", "Pawtucket", "East Providence"],
    areaCodes: ["401"],
    timezone: "Eastern",
    climate: "humid continental",
    seasonalNotes: "Four seasons. Coastal influence. Nor'easters. Relatively mild for New England.",
    hvacNotes: "Heating essential in winter. AC needed in summer. Many older homes.",
    plumbingNotes: "Freeze protection important. Coastal flooding concerns. Old infrastructure.",
    electricalNotes: "Storm outages from nor'easters. Older wiring common.",
    roofingNotes: "Wind resistance for coastal. Snow and ice. Historic homes."
  },
  SC: {
    name: "South Carolina",
    abbr: "SC",
    capital: "Columbia",
    majorCities: ["Charleston", "Columbia", "North Charleston", "Mount Pleasant", "Greenville"],
    areaCodes: ["803", "843", "854", "864"],
    timezone: "Eastern",
    climate: "humid subtropical",
    seasonalNotes: "Hot humid summers. Mild winters. Hurricane risk on coast. Occasional ice in upstate.",
    hvacNotes: "AC essential most of year. Humidity control critical. Mild heating needs.",
    plumbingNotes: "Minimal freeze risk except upstate. Hurricane prep on coast.",
    electricalNotes: "Hurricane hardening on coast. High humidity considerations.",
    roofingNotes: "Hurricane-rated on coast. Heat and humidity. Storm damage common."
  },
  SD: {
    name: "South Dakota",
    abbr: "SD",
    capital: "Pierre",
    majorCities: ["Sioux Falls", "Rapid City", "Aberdeen", "Brookings", "Watertown"],
    areaCodes: ["605"],
    timezone: "Central/Mountain",
    climate: "humid continental to semi-arid",
    seasonalNotes: "Cold winters, warm summers. Blizzards. Tornadoes. Black Hills different.",
    hvacNotes: "Heating critical. AC needed in summer. Wide temperature swings.",
    plumbingNotes: "Freeze protection essential. Rural well water. Hard water.",
    electricalNotes: "Rural areas may need generators. Storm damage.",
    roofingNotes: "Wind and hail damage. Snow loads. Extreme conditions."
  },
  TN: {
    name: "Tennessee",
    abbr: "TN",
    capital: "Nashville",
    majorCities: ["Nashville", "Memphis", "Knoxville", "Chattanooga", "Clarksville", "Murfreesboro"],
    areaCodes: ["423", "615", "629", "731", "865", "901", "931"],
    timezone: "Eastern/Central",
    climate: "humid subtropical",
    seasonalNotes: "Hot humid summers. Mild to cold winters. Tornadoes. Mountains cooler.",
    hvacNotes: "AC essential in summer. Heating needed in winter. Humidity control.",
    plumbingNotes: "Moderate freeze risk. Humidity issues. Karst geology affects drainage.",
    electricalNotes: "TVA provides power. Storm damage. Growing music city infrastructure.",
    roofingNotes: "All-weather needs. Hail damage. Mountains have snow."
  },
  TX: {
    name: "Texas",
    abbr: "TX",
    capital: "Austin",
    majorCities: ["Houston", "San Antonio", "Dallas", "Austin", "Fort Worth", "El Paso"],
    areaCodes: ["210", "214", "254", "281", "325", "346", "361", "409", "430", "432", "469", "512", "682", "713", "726", "737", "806", "817", "830", "832", "903", "915", "936", "940", "956", "972", "979"],
    timezone: "Central/Mountain",
    climate: "varied - humid to arid",
    seasonalNotes: "Huge state with varied climate. Hot most places. Gulf hurricanes. Rare but severe freeze events.",
    hvacNotes: "AC critical (runs 8+ months in south). Heat important after 2021 freeze. Grid concerns.",
    plumbingNotes: "Freeze events devastating when they occur. Hard water. Hurricane prep on coast.",
    electricalNotes: "ERCOT grid issues. Extreme summer demand. Hurricane hardening on coast.",
    roofingNotes: "Hail damage very common. Hurricane-rated on coast. UV and heat damage."
  },
  UT: {
    name: "Utah",
    abbr: "UT",
    capital: "Salt Lake City",
    majorCities: ["Salt Lake City", "West Valley City", "Provo", "West Jordan", "Orem", "Sandy"],
    areaCodes: ["385", "435", "801"],
    timezone: "Mountain",
    climate: "semi-arid to alpine",
    seasonalNotes: "Four seasons. Cold winters with great snow. Hot dry summers. Inversion in valleys.",
    hvacNotes: "Heating essential in winter. AC needed in summer. Low humidity helps. Air quality issues.",
    plumbingNotes: "Freeze protection important. Hard water. Drought awareness.",
    electricalNotes: "Solar growing. Ski resort areas have demands. Winter cold affects equipment.",
    roofingNotes: "Snow loads in mountains. UV exposure. Metal and tile roofs common."
  },
  VT: {
    name: "Vermont",
    abbr: "VT",
    capital: "Montpelier",
    majorCities: ["Burlington", "South Burlington", "Rutland", "Essex Junction", "Bennington", "Montpelier"],
    areaCodes: ["802"],
    timezone: "Eastern",
    climate: "humid continental",
    seasonalNotes: "Cold snowy winters. Beautiful fall. Mild summers. Ski season important. Maple sugaring.",
    hvacNotes: "Heating critical 6+ months. Wood and oil heat common. AC becoming more needed.",
    plumbingNotes: "Freeze protection essential. Many old farmhouses. Well water common.",
    electricalNotes: "Rural areas may need backup. Old wiring in historic buildings. Green energy focus.",
    roofingNotes: "Heavy snow loads. Ice dam prevention critical. Historic buildings. Metal roofs."
  },
  VA: {
    name: "Virginia",
    abbr: "VA",
    capital: "Richmond",
    majorCities: ["Virginia Beach", "Norfolk", "Chesapeake", "Richmond", "Arlington", "Newport News"],
    areaCodes: ["276", "434", "540", "571", "703", "757", "804"],
    timezone: "Eastern",
    climate: "humid subtropical",
    seasonalNotes: "Four seasons. Hot humid summers. Variable winters. Mountains get snow. Coast has hurricanes.",
    hvacNotes: "Both AC and heating essential. Humidity control. Wide regional variation.",
    plumbingNotes: "Moderate freeze risk. Coastal flooding. Historic buildings in older areas.",
    electricalNotes: "Storm damage varies by region. Dense NoVA infrastructure. Military bases.",
    roofingNotes: "All-weather needs. Mountains have snow. Coast needs wind resistance."
  },
  WA: {
    name: "Washington",
    abbr: "WA",
    capital: "Olympia",
    majorCities: ["Seattle", "Spokane", "Tacoma", "Vancouver", "Bellevue", "Kent"],
    areaCodes: ["206", "253", "360", "425", "509", "564"],
    timezone: "Pacific",
    climate: "oceanic to semi-arid",
    seasonalNotes: "Wet west, dry east. Mild temperatures west. Mountains have heavy snow. Volcanos.",
    hvacNotes: "Heating more important than AC west side. East needs both. Heat pumps very popular.",
    plumbingNotes: "Rain and moisture west. Freeze risk east and mountains. Earthquake prep.",
    electricalNotes: "Hydropower keeps rates low. Tech sector demand. Green energy leader.",
    roofingNotes: "Moss and moisture control west. Snow in mountains and east. Metal roofs popular."
  },
  WV: {
    name: "West Virginia",
    abbr: "WV",
    capital: "Charleston",
    majorCities: ["Charleston", "Huntington", "Morgantown", "Parkersburg", "Wheeling"],
    areaCodes: ["304", "681"],
    timezone: "Eastern",
    climate: "humid continental",
    seasonalNotes: "Four seasons. Cold winters in mountains. Warm summers. Flooding risk in valleys.",
    hvacNotes: "Heating important in winter. AC needed in summer. Many older homes.",
    plumbingNotes: "Freeze protection. Flood mitigation. Well water in rural areas.",
    electricalNotes: "Coal transition affecting industry. Rural backup needs. Older infrastructure.",
    roofingNotes: "Mountain snow loads. Steep terrain challenges. Older building stock."
  },
  WI: {
    name: "Wisconsin",
    abbr: "WI",
    capital: "Madison",
    majorCities: ["Milwaukee", "Madison", "Green Bay", "Kenosha", "Racine", "Appleton"],
    areaCodes: ["262", "414", "534", "608", "715", "920"],
    timezone: "Central",
    climate: "humid continental",
    seasonalNotes: "Cold winters (below 0°F common). Warm summers. Lake effect snow. Cheese curds.",
    hvacNotes: "Heating critical. High-efficiency needed. AC in summer. Dairy farm considerations.",
    plumbingNotes: "Freeze protection essential. Many basements. Rural well water.",
    electricalNotes: "Cold affects equipment. Rural backup needs. Industrial demand.",
    roofingNotes: "Heavy snow loads. Ice dam prevention. Cold weather materials."
  },
  WY: {
    name: "Wyoming",
    abbr: "WY",
    capital: "Cheyenne",
    majorCities: ["Cheyenne", "Casper", "Laramie", "Gillette", "Rock Springs"],
    areaCodes: ["307"],
    timezone: "Mountain",
    climate: "semi-arid to alpine",
    seasonalNotes: "Very windy. Cold winters, mild summers. Mountains have heavy snow. Low population.",
    hvacNotes: "Heating essential. Wind affects efficiency. AC less critical. Rural propane.",
    plumbingNotes: "Freeze protection critical. Rural well water. Hard water.",
    electricalNotes: "Wind energy growing. Rural areas need backup. Long distances.",
    roofingNotes: "Extreme wind resistance needed. Snow in mountains. Metal roofs common."
  }
};

// Get state by abbreviation or name
export function getState(identifier) {
  if (!identifier) return null;
  const upper = identifier.toUpperCase();
  if (stateData[upper]) return stateData[upper];
  
  // Search by name
  const byName = Object.values(stateData).find(
    s => s.name.toLowerCase() === identifier.toLowerCase()
  );
  return byName || null;
}

// Get all states as array
export function getAllStates() {
  return Object.entries(stateData).map(([abbr, data]) => ({
    abbr,
    ...data
  }));
}
